module.exports = __webpack_public_path__ + "static/media/ggy.4ad7b0ed.svg";